import styled from "styled-components";
import { DARK_GRAY, WHITE_COLOR } from "../../constants/color";
import UnicefBlueImage from "../../styles/images/UNICEF_Logo_Light.png";

export const ResponsiveBgImage = styled.img`
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  width: 100%;
  height: 100vh;
`;

export const ApplicationTitle = styled.span`
  position: absolute;
  top: 30px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 24px !important;
  color: #ffffffde;
  font-weight: bold;
`;

export const HomeRightSideWrapper = styled.div`
  background-color: ${WHITE_COLOR};
  background-image: url(${UnicefBlueImage});
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: contain;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;
